const massimo = () => {
  $(() => {

    $('.services_select').change(function() { //Initialize "On Select Change" listener
       var val = $(this).val(); //Get the value of the select
       $('html, body').animate({ //Animate the page scroll
         scrollTop: $(val).offset().top - 100 //scroll to div with the same ID as the selected value
       }, 500); //Animation length in MS: 2000 = 2 seconds
    });

    $(".link-ev-modal").click(function () {
      $(this).next(".modal").appendTo("#wrapperModalLavora");
      var dest = $(this).data("dest");
      const myModal = new Modal(dest);
      myModal.show();
    });

    $(".filtro_colore").parents(".woocommerce-widget-layered-nav-list").addClass("wrapper_filtro_colore");

    $("a.scroll-link, .scroll-link>a").click(function (e) {
      e.preventDefault();
      var link = $(this).attr("href");
      $("html, body").animate({ scrollTop: $("#" + link).offset().top - 200 }, 800);
    });

    // Scroll verso il div il cui id corrisponde all'ancora del link .servizio-cta
    function scrollToAnchor(hash, animate) {
      if (!hash || hash.charAt(0) !== "#" || hash.length < 2) return false;
      var $target = $(hash);
      if (!$target.length) return false;
      var offset = ($(".navbar-light").outerHeight() || 0) + 100;
      var top = $target.offset().top - offset;
      if (animate === false) {
        $("html, body").scrollTop(top);
      } else {
        $("html, body").animate({ scrollTop: top }, 800, "swing");
      }
      return true;
    }

    $(".servizio-cta").on("click", function (e) {
      var href = $(this).attr("href") || "";
      var i = href.indexOf("#");
      if (i === -1) return; // nessuna ancora, lascia il link normale
      var hash = href.substring(i);
      // Se il target esiste in questa pagina, scrolla; altrimenti naviga (cross-page)
      if ($(hash).length) {
        e.preventDefault();
        scrollToAnchor(hash);
      }
    });

    // Arrivo cross-page con hash (es. /servizi/#tab_xxx): scroll morbido al load
    if (window.location.hash && $(window.location.hash).length) {
      setTimeout(function () {
        scrollToAnchor(window.location.hash);
      }, 300);
    }

    $(".titolo_pb").each(function () {
      var ancora = $(this).data("ancora");
      if (!(typeof ancora === "undefined" || ancora === null)) {
        $(this).on("click", function () {
          if ($("#idmanuale_" + ancora).length) $("html, body").animate({ scrollTop: $("#idmanuale_" + ancora).offset().top }, 800);
          else console.log("#idmanuale_" + ancora + " non trovato!!");
        });
      }
    });

    if ($(window).width() < 990) {
      $(".mobile-toggler .titolo_pb").click(function () {
        $(this).toggleClass("aperto");
        $(this).parents(".mobile-toggler").toggleClass("aperto");
      });
    }
  });
};

export default massimo;
